import { Container } from "./ui/container";

export function PageLoading({ label = "Loading…" }: { label?: string }) {
  return <Container className="min-h-[calc(100svh-5rem)] py-12" aria-busy="true" aria-live="polite">
    <span className="sr-only">{label}</span>
    <div className="animate-pulse" aria-hidden="true">
      <div className="h-3 w-28 rounded-full bg-gold/20" />
      <div className="mt-4 h-10 max-w-xl rounded-xl bg-ink-border/55" />
      <div className="mt-3 h-4 max-w-md rounded-full bg-ink-border/35" />
      <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 6 }, (_, index) => (
          <div key={index} className="h-36 rounded-2xl border border-ink-border/60 bg-white/35" />
        ))}
      </div>
    </div>
  </Container>;
}

export function PageError({ error, title = "Something went wrong" }: { error?: Error; title?: string }) {
  return <Container className="py-20 text-center"><h1 className="font-display text-2xl font-semibold text-ivory">{title}</h1><p className="mt-3 text-sm text-red-soft">{error?.message ?? "Please try again."}</p></Container>;
}

export function EmptyState({ children }: { children: string }) {
  return <div className="rounded-2xl border border-dashed border-ink-border bg-white/45 px-6 py-10 text-center text-sm text-ivory-muted">{children}</div>;
}
